export default {"src":"/_next/static/media/logo-dark.aa3e5875.svg","height":24,"width":128,"blurWidth":0,"blurHeight":0};